import React from "react";
import { finApi, money } from "@/lib/financeApi";
import { Empty, ErrorBox, Loading, useLoad } from "@/components/nds/windows/finance/parts";
import { TxTable } from "@/components/nds/windows/finance/OutsideIncomeTab";

export default function SavingsBalanceTab({ resident }) {
  const [state, load] = useLoad(() => Promise.all([
    finApi.get(`/residents/${resident.id}/balances`),
    finApi.get(`/residents/${resident.id}/ledger`, { bucket: "savings", page_size: 200 }),
  ]).then(([b, l]) => ({ balance: b.balances.savings, loan: b.balances.loan, items: l.items, total: l.total })), [resident.id]);

  if (state.loading && !state.data) return <Loading testid="fin-savings-balance-loading" />;
  if (state.error) return <ErrorBox testid="fin-savings-balance-error" error={state.error} onRetry={load} />;
  const { balance, loan, items, total } = state.data;
  return (
    <div data-testid="fin-savings-balance-tab" className="p-5 space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <div className="p-4 border border-nex-gold/30 rounded-sm">
          <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-nex-muted">Custody savings</div>
          <div data-testid="fin-savings-current" className="mt-2 font-mono text-2xl text-nex-gold">{money(balance)}</div>
        </div>
        <div className="p-4 border border-white/10 rounded-sm">
          <div className="font-mono text-[9px] tracking-[0.2em] uppercase text-nex-muted">Line of Credit</div>
          <div data-testid="fin-savings-loan" className={`mt-2 font-mono text-2xl ${loan < 0 ? "text-red-300" : "text-nex-muted"}`}>{money(loan)}</div>
        </div>
      </div>
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">Savings history · {total} rows</div>
      {items.length ? <TxTable testid="fin-savings-history" items={items} /> : <Empty testid="fin-savings-history-empty">No savings activity yet.</Empty>}
    </div>
  );
}
